import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesResellers } from "../../constants";
import { UpdateResellerBody } from "./updateReseller.types";

export const requestUpdateReseller = async ({
  resellerId,
  ...body
}: UpdateResellerBody): Promise<void> => {
  return await instance.patch(
    buildUrl(ApiRoutesResellers.Reseller, resellerId),
    body
  );
};
